'use client';

import { useId, useState } from 'react';
import styles from './Switch.module.css';

export interface SwitchProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  id?: string;
}

export const Switch = ({
  checked,
  defaultChecked = false,
  onChange,
  disabled,
  label,
  id,
}: SwitchProps) => {
  const reactId = useId();
  const switchId = id ?? reactId;
  const isControlled = checked !== undefined;
  const [internal, setInternal] = useState(defaultChecked);
  const on = isControlled ? checked : internal;

  const toggle = () => {
    if (disabled) return;
    const next = !on;
    if (!isControlled) setInternal(next);
    onChange?.(next);
  };

  return (
    <span className={styles.wrap}>
      <button
        type="button"
        role="switch"
        id={switchId}
        aria-checked={on}
        aria-label={label}
        disabled={disabled}
        onClick={toggle}
        className={styles.track}
        data-on={on || undefined}
      >
        <span className={styles.thumb} />
      </button>
    </span>
  );
};
